import axios from "api/axios.js";

let isMounted = true;
const controller = new AbortController();
const clientsUrl = "/budget/archive";
export async function getBudgetArchive(id) {
  try {
    const response = await axios.get(`${clientsUrl}/${id}`, {
      signal: controller.signal,
    });
    return response;
  } catch (err) {
    console.error(err);
  }
  return () => {
    isMounted = false;
    controller.abort();
  };
}
